import * as React from 'react';
import Paper from '@mui/material/Paper';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import LogoutIcon from '@mui/icons-material/Logout';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { FaChartBar,FaChartLine } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const CustomSpeedDial = () => {
 const [value, setValue] = React.useState();
  const navigate = useNavigate(); // or use window.location.href

   const handleNavigation = (newValue) => {
    setValue(newValue);

    switch (newValue) {
      case 0:
        navigate("/menu-list");
        break;
      case 1:
        navigate("/report-byevent"); // replace with correct route
        break;
      case 2:
        navigate("/report-bymix");
        break;
      case 3:
        navigate("/login");
        break;
      default:
        break;
    }
  };

 return (
   <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1300 }} elevation={3}>
     <BottomNavigation
       showLabels
       value={value}
       className='dark:bg-custom_dark_primary2'
       onChange={(event, newValue) => handleNavigation(newValue)}
       sx={{
         '& .Mui-selected': {
           color: 'primary.main', // or your desired selected color
         }
       }}
     >
       <BottomNavigationAction label="Menu" icon={<MenuIcon className='dark:text-customWhite'/>} className='dark:bg-custom_dark_primary2 dark:text-customWhite'/>
       <BottomNavigationAction label="By Event" icon={<FaChartBar className='dark:text-customWhite'/>} className='dark:bg-custom_dark_primary2 dark:text-customWhite'/>
       <BottomNavigationAction label="By Mix" icon={<FaChartLine className='dark:text-customWhite'/>} className='dark:bg-custom_dark_primary2 dark:text-customWhite'/>
       <BottomNavigationAction label="Log Out" icon={<LogoutIcon className='dark:text-customWhite'/>} className='dark:bg-custom_dark_primary2 dark:text-customWhite'/>
     </BottomNavigation>
   </Paper>
  );
}

export default CustomSpeedDial;